import { useState } from "react";
import { Handshake, Menu, X } from "lucide-react";
import { NAV } from "@/constants/testIds";
import { useVerificationDialog } from "@/contexts/VerificationDialogContext";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ps-medical-logistics/artifacts/1dt4h2l7_Gemini_Generated_Image_dpwsejdpwsejdpws.png";

const navLinks = [
  { label: "Services", href: "/#services", testId: NAV.linkServices },
  { label: "How It Works", href: "/#methodology", testId: NAV.linkVerification },
  { label: "Engagement", href: "/#engagement", testId: "nav-link-engagement" },
  { label: "Compliance", href: "/#compliance", testId: NAV.linkPortfolio },
  { label: "Contact", href: "/contact", testId: "nav-link-contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { openDialog } = useVerificationDialog();

  function handleStartSourcing() {
    setOpen(false);
    openDialog();
  }

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-slate-200/80">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 h-20 flex items-center justify-between">
        <a
          href="/"
          data-testid={NAV.logo}
          className="flex items-center gap-3 group"
        >
          <img
            src={LOGO_URL}
            alt="PS GLOBAL SERIES, LLC"
            className="h-9 w-9 object-contain"
          />
          <div className="leading-tight">
            <div className="font-display text-[15px] sm:text-[16px] font-bold tracking-tight text-slate-900">
              PS GLOBAL SERIES
            </div>
            <div className="eyebrow text-[10px] mt-0.5">
              B2B Sourcing Agency · US–DR Trade
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testId}
              className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors relative after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-slate-900 hover:after:w-full after:transition-all after:duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={handleStartSourcing}
            data-testid={NAV.requestAccessBtn}
            className="hidden sm:inline-flex items-center gap-2 bg-slate-900 text-white px-5 py-2.5 text-sm font-semibold tracking-tight hover:bg-slate-800 transition-colors rounded-sm shadow-sm"
          >
            <Handshake size={15} />
            Start Sourcing
          </button>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            data-testid={NAV.mobileMenuBtn}
            aria-label="Toggle menu"
            className="md:hidden inline-flex items-center justify-center h-10 w-10 border border-slate-300 rounded-sm text-slate-700"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white">
          <div className="px-6 py-4 flex flex-col gap-3">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-slate-700 py-2"
              >
                {l.label}
              </a>
            ))}
            <button
              type="button"
              onClick={handleStartSourcing}
              data-testid="nav-request-access-btn-mobile"
              className="mt-2 inline-flex items-center justify-center gap-2 bg-slate-900 text-white px-5 py-3 text-sm font-semibold rounded-sm"
            >
              <Handshake size={15} />
              Start Sourcing
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
